const Created = 0;
const Deleted = 1;

export default {
	Created,
	Deleted,
};
